import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CompareCloudCompaniesDialogComponent } from '@app/client/compare-cloud-companies/compare-cloud-companies-dialog.component';
import { PartnerProgramSelectors } from '@app/core/state/partnerprogram/partnerprogram.selectors';
import { BlFrontendAlertComponent } from '@app/core/wrappers/bl-frontend-alert.component';
import { openTranslatableDialog } from '@app/shared/misc/openDialog';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';

@Component({
  selector: 'app-missing-partner-packages-alert',
  template: `
    <ng-container *transloco="let t; prefix: scope">
      <div class="w-full mb-6" *ngIf="(missingPartnerPackages$ | async) > 0">
        <bl-frontend-alert
          severity="warning"
          [header]="t('alertHeader')"
          [listItems]="[
            {
              text: t('notConnectedProPackagesText'),
            },
            {
              text: t('notConnectedEssentialPackagesText'),
            },
          ]"
          [link]="{
            text: t('manageConnectionNow'),
            onClick: openCompareToCloudCompanyDialog,
          }"
          [dismissable]="false">
        </bl-frontend-alert>
      </div>
    </ng-container>
  `,
  standalone: true,
  imports: [CommonModule, BlFrontendAlertComponent, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DialogService, getTranslationProvider('MissingPartnerPackagesAlertComponent')],
})
export class MissingPartnerPackagesAlertComponent extends TranslatableComponent {
  missingPartnerPackages$: Observable<number>;

  constructor(private dialogService: DialogService) {
    super();
    this.missingPartnerPackages$ = this.store.select(PartnerProgramSelectors.missingPartnerProgramPackages);
  }

  openCompareToCloudCompanyDialog = () => {
    openTranslatableDialog({
      deps: { dialogService: this.dialogService, translationService: this.translationService, store: this.store },
      componentType: CompareCloudCompaniesDialogComponent,
      data: { clients: [] },
    }).subscribe();
  };
}
